import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Home|Profile|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPHomeProfileHistory';
export type SPHomeProfileLocNames = `${LocNameStart}TitlePage` | `${LocNameStart}TitleEmailHistory`;

export const spHomeProfileLocs: LocDefs<SPHomeProfileLocNames> = {
	SPHomeProfileHistoryTitlePage: {
		defaultValue: 'Profile',
		description: 'Page title.',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Core/Users.Profile.Title.Profile',
		...sharedProperties,
	},
	SPHomeProfileHistoryTitleEmailHistory: {
		defaultValue: 'Email History',
		description: 'Email history title.',
		displayPath: `${pathStart}Email history Title`,
		displayType: 'Title',
		legacyName: 'Core/Users.Profile.Content.EmailHistory',
		...sharedProperties,
	},
};

export type SPHomeProfileLocType = LocMap<SPHomeProfileLocNames>;
